import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Purpose } from 'src/app/core/models/purpose';
import { PurposeService } from 'src/app/core/services/general/purpose.service';

@Component({
  selector: 'app-purpose-input',
  templateUrl: './purpose-input.component.html',
  styleUrls: ['./purpose-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PurposeInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PurposeInputComponent,
    },
  ],
})
export class PurposeInputComponent {
  @Input()
  title = "Select Purpose...";

  @Input()
  isDisabled = false;

  @Output()
  onCheckHasContainerTransaction = new EventEmitter<boolean>();

  public value?: string;
  public localValue?: CustomSelectOption;

  public purposesList: Array<CustomSelectOption> = [];
  public purposes: Array<Purpose> = [];

  constructor(
    private purposeService: PurposeService,
  ) {
    this.purposeService
      .all()
      .subscribe((res: Array<Purpose>) => {
        this.purposesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.purposes = res.map((el) => {
          return new Purpose(el);
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.purposesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.onCheckHasContainerTransaction.emit(this.purposes.find(p => p.uuid === this.value)?.has_container_transaction);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
